import { Injectable } from '@angular/core';
import { ETransfersServiceCode } from '@common/models';
import { CommonService } from 'src/app/common.service';
import { IContextualMenu } from 'src/app/common/models/contextual-menu.model';
import { ProcessShellService } from 'src/app/process-shell/services/process-shell.service';
import { Beneficiaries } from '../beneficiaries-service/beneficiaries.model';
import {
  CriteriaQuery,
  HttpProviderService, HttpRequest
} from '@fpx/core';
import { IHttpSuccessPayload,ILookupResponse } from '@fpx/core';
import { add } from '@amcharts/amcharts4/.internal/core/utils/Array';
import { map, Observable, of,catchError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TransfersMainService } from './transfers-main.service';
import { BeneficiariesService } from '../beneficiaries-service/beneficiaries.service';

@Injectable({
  providedIn: 'root'
})
export class BeneficiaryMainService {

  allBeneficiaryList:Beneficiaries[]=[];
  isBeneficiaryEmpty:boolean = true;
  currentServiceCode: any;

  constructor(public processShellService : ProcessShellService,
    public beneficiariesService : BeneficiariesService,
    public transfersMainService : TransfersMainService,
    public _httpProvider : HttpProviderService){

  }

  emptyAllBeneficiaryList(){
    this.allBeneficiaryList = []
    this.isBeneficiaryEmpty = true;
  }

  getBeneInitial(beneName: string) {
    if (beneName && beneName != '') {
      let initial: string = beneName.charAt(0);
      if (beneName.split(' ').length > 1) {
        initial = initial + beneName.split(' ')[1].charAt(0);
      }
      return initial;
    }
    return
  }



  getwithinBankAccount(key): Observable<any> {
      const httpRequest = new HttpRequest();

      httpRequest.setResource('/casaaccount/{serviceCode}');
      httpRequest.setServerContext(environment.accountsPublisher)
      httpRequest.addPathParameter('serviceCode', key);
      httpRequest.addQueryParameter('mode', '1');
      httpRequest.setMethod('GET');
      return this._httpProvider
        .invokeRestApi(httpRequest)
        .pipe(map((res: IHttpSuccessPayload<any>) => res ?? null),catchError((err:any) => {
              return err
            }));
  }

  beneNickNameValidation(beneNickName):Observable<any>{

      const httpRequest = new HttpRequest();
      httpRequest.setServerContext(environment.transfersPublisher);
      httpRequest.setResource('/beneficiaries');
      httpRequest.setMethod('GET');
      let cretiaria = new CriteriaQuery();
      cretiaria.setPaginationCriteria('1',10000)
      cretiaria.addFilterCritertia('beneNickName', 'String', 'equals', {
        searchText:  beneNickName ?? '',
        });
      cretiaria.addFilterCritertia('status', 'String', 'equals', {
        searchText:  'S',
          });
      httpRequest.setCriteriaQuery(cretiaria);
      return this._httpProvider
        .invokeRestApi(httpRequest)
        .pipe(
          map(
            (res: IHttpSuccessPayload<any>) =>{
             return{
              data:res.body?.beneficiaries || [],
              totalRowCount: res.body?.totalRowCount
              }
            }
          )
        );
  
  }
  
  beneAccNoValidation(accountNumber):Observable<any>{

    const httpRequest = new HttpRequest();
    httpRequest.setServerContext(environment.transfersPublisher);
    httpRequest.setResource('/beneficiaries');
    httpRequest.setMethod('GET');
    let cretiaria = new CriteriaQuery();
    cretiaria.setPaginationCriteria('1',10000)
    cretiaria.addFilterCritertia('beneIdentifier', 'String', 'equals', {
      searchText:  accountNumber ?? '',
      });
    cretiaria.addFilterCritertia('status', 'String', 'equals', {
        searchText:  'S',
          });
    httpRequest.setCriteriaQuery(cretiaria);
    return this._httpProvider
      .invokeRestApi(httpRequest)
      .pipe(
        map(
          (res: IHttpSuccessPayload<any>) =>{
           return{
            data:res.body?.beneficiaries || [],
            totalRowCount: res.body?.totalRowCount
            }
          }
        )
      );

}
  getSpecifiedSystemBeneList(processode):Beneficiaries[]{
    let beneNameSort:Beneficiaries[] = this.getSortedArray(this.allBeneficiaryList, 'beneName');
    if(processode == 'INTBT'){
      beneNameSort = beneNameSort.filter(x=> x.serviceCode == 'BENEINTBT');
    }else if(processode == 'SWIFT'){
      beneNameSort = beneNameSort.filter(x=> x.serviceCode == 'BENESWIFT');
    }
    else if(processode == 'IFSC'){
      beneNameSort = beneNameSort.filter(x=> x.serviceCode == 'BENEIFSC');
    }
    else if(processode == 'INTRACSEND'){
      beneNameSort = beneNameSort.filter(x=> x.serviceCode == 'BENEINTRAC');
    }
    else if(processode == 'INTRACREQUEST'){
      beneNameSort = beneNameSort.filter(x=> x.serviceCode == 'BENEINTRAC');
    }
    else if(processode == 'DOMESTIC'){
      beneNameSort = beneNameSort.filter(x=> x.serviceCode == 'BENEDOMESTIC');
    }
    return beneNameSort;
  }

  getStructuredBeneData(serviceCode,transerviceCode?):Beneficiaries[] {
    let beneNameSort:Beneficiaries[] = this.getSortedArray(this.allBeneficiaryList, 'beneName');

    if(this.processShellService.processCode == 'MANAGEBENEFICIARY' && serviceCode !='FAV' && serviceCode !='ALL'){
        beneNameSort = serviceCode?beneNameSort.filter(x=> x.serviceCode == serviceCode):beneNameSort;
    }else if(this.processShellService.processCode != 'MANAGEBENEFICIARY'){
      if(transerviceCode == 'TRANINTBT'){
        beneNameSort = beneNameSort.filter(x=> x.serviceCode == 'BENEINTBT');
      }
      else if(transerviceCode== 'TRANDOMESTIC'){
        beneNameSort = beneNameSort.filter(x=> x.serviceCode == 'BENEDOMESTIC');
      }
    }

    if(serviceCode =='FAV'){
      beneNameSort = beneNameSort.filter(x=> x.isFavourite=='1');
    }
    if(serviceCode =='ALL'){
      beneNameSort = beneNameSort
    }

    let initial;
    let data:any[] = [];
    beneNameSort?.forEach(element=>{
      if(element?.beneNickName?.charAt(0)!=""){
        if(!initial || initial!=element?.beneNickName?.charAt(0)?.toLocaleUpperCase()){
          initial = element?.beneNickName?.charAt(0)?.toLocaleUpperCase();
          data.push({initial:element?.beneNickName?.charAt(0)?.toLocaleUpperCase(), isRowGroupHeader: true, beneNickName:element?.beneNickName})
        }
        data.push(element)
    }

    })
    if(!beneNameSort || beneNameSort?.length==0){
      this.isBeneficiaryEmpty = true;
    }else{
      this.isBeneficiaryEmpty = false;
    }
    return data;
  }

  getSortedArray(arr,sortByName) {
    if(arr){
      return arr?.sort( function( a, b ) {
          a = a[sortByName]?.toLowerCase();
          b = b[sortByName]?.toLowerCase();
          return a < b ? -1 : a > b ? 1 : 0;
      });
    }else{
      return undefined;
    }
  }

  getServiceCodeByFormName(formName) {
    switch (formName) {
      case 'OwnAccountTransferForm': return 'OAT'
      case 'WithinBankTransferForm': return 'INTBT'
      case 'DomesticTransferForm': return 'DOMESTIC'
      case 'SwiftTransferForm': return 'SWIFT'
    }
  }


  getBeneById(beneId: string):Beneficiaries {
    return this.allBeneficiaryList?.find(x=>x.beneId==beneId)
  }




}
